export const STOCK_TRANSFERS_STATES_LABELS = {
    Created: 'Créé',
    Validated: 'Validé',
    Aborted: 'Annulé',
};
